import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { AdTypeColumn as AdTypeColumnConfig } from '@bingads-webui-campaign/ads-data';
import adTypeTemplate from './ad-type.pug';

export class AdTypeColumn extends CampaignuiBaseColumn {
  constructor({
    i18n, newI18n, permissions,
  }) {
    const title = i18n.getString('ColumnName_AdType');
    super({
      ...AdTypeColumnConfig,
      title,
      sortable: 'Type',
      type: 'string',
      helpId: 'pop_BA_NewAdCreate_AdType',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.permissions = permissions;
    this.schemaI18n = new SchemaI18n({ i18n });
    this.newI18n = newI18n;
  }

  template({ value }) {
    if (this.permissions.IsMultiMediaAdsEnabled && value === 'Responsive') {
      // When enable IsMultiMediaAdsEnabled, show text as "Responsive ad / Multimedia ad"
      value = 'Multimedia'; // eslint-disable-line no-param-reassign
    }
    if (this.permissions && this.permissions.dynamic && this.permissions.dynamic.IsRenameHotelToLodgingEnabled && value === 'Hotel') {
      // When enable IsRenameHotelToLodgingEnabled, show text as "Lodging"
      value = 'Lodging'; // eslint-disable-line no-param-reassign
    }
    const isDisableEXTA = value === 'ExpandedText';

    const isStandardTextAd = value === 'Text';

    return adTypeTemplate({
      value, schemaI18n: this.schemaI18n, isDisableEXTA, isStandardTextAd,
    });
  }
}
